<template lang="pug">
v-dialog(
    v-model="show",
    width="auto",
    scrollable,
    max-width="700px",
    persistent,
    v-if="variacoes"
)
    form(
        @submit.prevent="validate('variacao')",
        data-vv-name="variacao",
        style="width: 100%"
    )
        v-card.Poppins(style="border-radius: 10px; ")
            v-card-title
                span.title.Poppins Selecionar Categoria de Variação
            v-card-text(style="max-height: 500px")
                v-layout(row, wrap)
                    v-flex.xs12
                        v-select.Poppins.inputDefault(
                            color="gray",
                            label="Variação",
                            return-object,
                            :disabled="!variacoes.length",
                            item-text="nome",
                            item-value="id",
                            :items="variacoes",
                            required,
                            v-validate="'required'",
                            :error-messages="errors.collect('categoria')",
                            data-vv-name="categoria",
                            type="text",
                            v-model="variacao",
                            outline,
                            autofocus
                        )
                            template(slot="selection", slot-scope="data")
                                span.Poppins {{ data.item.nome }}
                            template(slot="item", slot-scope="data")
                                v-list-tile-content
                                    v-list-tile-title.Poppins {{ data.item.nome }}
                                    v-list-tile-sub-title.caption.lb-danger--text.Poppins(
                                        v-if="data.item.itens_vinculados.length"
                                    ) Complemento utilizado em outros {{ data.item.itens_vinculados.length }} itens
                v-layout(row, wrap, v-if="variacao")
                    v-flex.xs12
                        v-list
                            div(v-for="item in variacao.allItens", :key="item.id")
                                v-list-tile(avatar)
                                    v-list-tile-content
                                        v-list-tile-title.Poppins {{ item.nome }}
                                        v-list-tile-sub-title.Poppins {{ item.descricao }}
                                    v-list-tile-action.Poppins {{ item.preco | currency }}
                                v-divider
                v-flex.md12.xs12.pt-0(v-if="variacao")
                  span.error--text.Poppins Atenção! Quaisquer alterações realizadas nessa Variação também serão alteradas em todos os itens que a compartilham.
                v-flex.md12.xs12.pt-0(v-bind:class="[$root.mobile ? 'areaAbtnsComplementos' : '']")
                    v-card-actions.right(v-if="($root.user.permissao_cardapio)")
                        v-spacer(v-if="!$root.mobile")
                        v-btn.btnSalvar(
                            depressed,
                            color="primary",
                            type="submit",
                            :loading="loading",
                            :disabled="loading || !variacao || variacao.item_catalogo_especial"
                            ) Salvar
                    v-btn.right(
                        type="button",
                        flat,
                        color="gray darken-1",
                        @click.native="show = false; variacao=null; variacoes=null, item=null"
                    ) Fechar
</template>

<script>
export default {
    $_veeValidate: {
        validator: "new",
    },
    data: () => ({
        show: false,
        loading: false,
        item: null,
        variacoes: null,
        variacao: null
    }),
    mounted() { },
    watch: {},
    methods: {
        open(variacoes, item) {
            this.show = true;
            this.variacoes = variacoes;
            this.item = item;
        },
        async validate() {
            try {
                this.loading = true;

                const result = await this.$validator.validateAll('item_variacao');

                if (!result) throw "Preencha todos os campos corretamente!";

                this.save(this.variacao);

                this.loading = false;
                this.show = false;

            } catch (error) {
                window.getApp.$emit("APP_ALERT", { color: "red", text: error });
                this.loading = false;
            }
        },
        async save(variacao) {
            try {
                if (
                    variacao.mod_preco > 1 &&
                    _.countBy(this.item.variacoes, (v) => v.mod_preco > 1).true
                ) {
                    this.loading = false;
                    return window.getApp.$emit("APP_ALERT", {
                        color: "red",
                        text: "Não é possível ter mais de 1 complemento que substitui o valor do item!",
                    });
                }
                const response = await this.$axios.post("/catalogo/variacao", {
                    categoria_id: variacao.id,
                    item_catalogo_id: this.item.id,
                });

                variacao.variacao_id = response.data.id;

                this.$emit('refresh-variacoes', variacao);

                this.loading = false;
                this.$validator.reset();

                window.getApp.$emit("APP_ALERT", {
                    color: "success",
                    text: "Categoria de complemento adicionada com sucesso!",
                });

            } catch (error) {
                console.log(error)
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao adicionar a categoria de complemento. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
                this.loading = false;
            }
        }
    }
};
</script>

<style lang="scss">
.inputDefault .v-input__control .v-input__slot{
    background-color: #f6f6f6!important;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, .15)!important;
}

.inputDefault.v-input.v-input--is-focused .v-input__control .v-input__slot{
    border: 1px solid #1d9a5a !important;
}
</style>

<style scoped>
.Poppins{
  font-family: 'Poppins', 'Roboto', sans-serif !important;
}
.areaAbtnsComplementos{
    padding: 0 !important;
    justify-content: flex-start;
    display: flex;
    flex-flow:column wrap;
    align-content: stretch;
    align-items: stretch;
}
.btnSalvar{
    width: 100%;
    border-radius: 5px !important;
    color:#fff;
    font-weight: 600;
}
</style>
